module.exports = __webpack_public_path__ + "img/f3-6.e4f4efdd.png";